import { Component, OnInit, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'app-input-loader',
  templateUrl: './input-loader.component.html',
  styleUrls: ['./input-loader.component.scss']
})
export class InputLoaderComponent implements OnInit {
  @HostBinding('class')
  @Input()
  customClass: string = '';
  @Input() active: boolean = false;

  @HostBinding('style')
  @Input()
  customStyle: string = '';

  constructor() {}

  ngOnInit(): void {}
}
